import { Button, DialogActions, DialogContent, Skeleton } from "@mui/material";
import React, { useState } from "react";
import { COMMOM_STATUS, orderStatusFormatted } from "src/constant";
import useWarehouseTransferReview from "src/hooks/warehouse-transfer/useWarehouseTransferReview";
import DeliveredReceipt from "src/pages/orders/all-order/export-form/DeliveredReceipt";
import useProcessLogDetail from "src/hooks/process-log/useProcessLogDetail";
import useWarehouseTransferExport from "src/hooks/warehouse-transfer/useWarehouseTranferExport";
import appConfig from "src/config/env";
import { enqueueSnackbar } from "notistack";

export default function DebtWarehousePrintDialog({ item, transferFileType = orderStatusFormatted.Exported, isHistoryDetail = false }) {
  const [logId, setLogId] = useState(null);
  const { mutate } = useProcessLogDetail(logId);
  const { trigger: printWT } = useWarehouseTransferExport();
  const { data, isLoading } = useWarehouseTransferReview(item?.contextId, {
    transferFileType,
  });

  const handleGetLog = (logIdParam) => {
    const logIdToUse = logIdParam || logId;
    if (!logIdToUse) return;

    const timeOut = setInterval(async () => {
      try {
        const res = await mutate();
        if (res?.success) {
          if (res.data.status === COMMOM_STATUS.done) {
            if (Array.isArray(res.data?.urls)) {
              res.data.urls.forEach((v) => {
                window.open(`${appConfig.API_FILE}/${v}`, "_blank");
              });
            }
            clearInterval(timeOut);
          }

          if (res.data.status === COMMOM_STATUS.error) {
            enqueueSnackbar("Không xuất được đơn", { variant: "error" });
            clearInterval(timeOut);
          }
        }
      } catch (err) {
        clearInterval(timeOut);
      }
    }, 1000);
  };

  const handlePrint = async () => {
    const transferFileTypeToUse = isHistoryDetail ? (item.type === "Outbound" ? orderStatusFormatted.Exported : orderStatusFormatted.Imported) : transferFileType;
    const res = await printWT({
      body: {
        warehouseTransferIds: [item?.contextId],
        transferFileType: transferFileTypeToUse,
      },
    });
    if (res?.success) {
      setLogId(res?.data?._id);
      handleGetLog(res?.data?._id);
      return enqueueSnackbar("Tiến hành xuất phiếu...", { variant: "success", className: 'notistack-confirm' });
    } else {
      return enqueueSnackbar(res?.error?.message ?? res?.error?.message, {
        variant: "error",
      });
    }
  };
  return (
    <>
      <DialogContent>
        {isLoading ? (
          Array.from({ length: 10 }, (_, i) => {
            return (
              <Skeleton
                key={i}
                width="100%"
                height="44px"
              />
            );
          })
        ) : (
          <DeliveredReceipt
            isLoading={isLoading}
            html={data}
          />
        )}
      </DialogContent>
      <DialogActions sx={{ p: "0px 12px 24px" }}>
        <Button
          onClick={handlePrint}
          fullWidth
          variant="contained"
        >
          In phiếu
        </Button>
      </DialogActions>
    </>
  );
}
